import { render, staticRenderFns } from "./traceabilityCode.vue?vue&type=template&id=56aa90cd&scoped=true"
import script from "./traceabilityCode.vue?vue&type=script&lang=js"
export * from "./traceabilityCode.vue?vue&type=script&lang=js"
import style0 from "./traceabilityCode.vue?vue&type=style&index=0&id=56aa90cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa90cd",
  null
  
)

export default component.exports